import { render, staticRenderFns } from "./FooterMenuQuest.vue?vue&type=template&id=254d2e04&scoped=true&"
import script from "./FooterMenuQuest.vue?vue&type=script&lang=js&"
export * from "./FooterMenuQuest.vue?vue&type=script&lang=js&"
import style0 from "./FooterMenuQuest.vue?vue&type=style&index=0&id=254d2e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d2e04",
  null
  
)

export default component.exports